import _ from 'lodash';

/* @ngInject */
export default function AggregatedEventDetailsModalController(
  $uibModalInstance,
  aggregatedEventDygraph,
  allAggregatedEvents
) {
  const vm = this;
  vm.$onInit = init;

  function init() {
    vm.currentIndex = 0;
    vm.dataPointName = aggregatedEventDygraph.name;
    // Although not used in the html, the 'vm' is used to satisfy the unit test
    vm.allAggregatedEvents = allAggregatedEvents;
    // Convert the aggregated event from Dygraph's time since epoch in milliseconds to an ISODate format
    const aggregatedEventDygraphEventDateString = new Date(aggregatedEventDygraph.xval).toISOString();
    // Using the ISODate, determine the index of the aggregated event in the allAggregatedEvents array
    vm.currentIndex = _.findIndex(
      allAggregatedEvents,
      ev => new Date(ev.eventDate).toISOString() === aggregatedEventDygraphEventDateString
    );

    if (vm.currentIndex < 0) {
      $uibModalInstance.dismiss('event not found');
    }
    // Use the current index to set the current aggregatedEvent to display in the modal
    setEvent(vm.currentIndex);
  }

  function setEvent(indexToSet) {
    vm.aggregatedEvent = angular.copy(allAggregatedEvents[indexToSet]); // to protect original aggregated event
    // Format the aggregated event's date for display in the modal
    vm.eventDateDisplay = new Date(vm.aggregatedEvent.eventDate).toString();
    vm.dataPointSecondList = vm.aggregatedEvent.data[vm.dataPointName].points;
    return true; // just to please eslint
  }

  // Close the modal instance
  vm.close = () => $uibModalInstance.dismiss('close');

  // Determine if there is more than one aggregated event in the allAggregatedEvents array to cycle through
  vm.canCycle = () => _.isArray(allAggregatedEvents) && allAggregatedEvents.length > 1;

  // Determine if there are any previous aggregated events
  vm.canCyclePrev = () => vm.currentIndex - 1 >= 0;

  // Determine if there are any previous aggregated events
  vm.canCycleNext = () => vm.currentIndex + 1 < allAggregatedEvents.length;

  // Cycle to the previous aggregated event
  vm.prev = () => {
    if (vm.canCyclePrev()) {
      vm.currentIndex -= 1;
      setEvent(vm.currentIndex);
    }
  };

  // Cycle to the next aggregated event
  vm.next = () => {
    if (vm.canCycleNext()) {
      vm.currentIndex += 1;
      setEvent(vm.currentIndex);
    }
  };

  // Obtain the total number of aggregated events
  vm.numberOfAllAggregatedEvents = allAggregatedEvents.length;
}

